"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../utils");
var _Flyout = _interopRequireDefault(require("./Flyout"));
var _FlyoutContext = require("./FlyoutContext");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WithFlyoutWithoutDocs = _ref => {
  let {
    children,
    renderFlyout,
    shouldCloseOnClickOutside,
    flyoutPosition = _constants.withFlyoutDefaultProps.flyoutPosition,
    onClose,
    role,
    zIndex,
    ...forwardedProps
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const flyoutTitleId = (0, _react.useMemo)(() => (0, _utils.getUniqueId)("".concat(_constants.FLYOUT_TITLE_ID, "-")), []);
  const ref = (0, _react.useRef)(null);
  const open = (0, _react.useCallback)(() => {
    setIsOpen(true);
  }, []);
  const close = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const closeWithCallback = () => {
    close();
    !!onClose && onClose();
  };
  return (0, _react2.jsx)(_FlyoutContext.FlyoutContext.Provider, {
    value: {
      flyoutRef: ref,
      flyoutTitleId,
      isInFlyout: true
    }
  }, children({
    open,
    close,
    isOpen
  }), (0, _react2.jsx)(_Flyout.default, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    ref: ref,
    isOpen: isOpen,
    close: closeWithCallback,
    shouldCloseOnClickOutside: shouldCloseOnClickOutside,
    position: flyoutPosition,
    role: role,
    "aria-labelledby": flyoutTitleId,
    zIndex: zIndex
  }), renderFlyout({
    close: closeWithCallback,
    ref
  })));
};
const WithFlyoutWithDocs = (0, _stencilReactDesc.describe)(WithFlyoutWithoutDocs).description('FAC component for displaying a flyout.');
WithFlyoutWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function used to trigger a flyout.').format("({\n  open: () => void,\n  close: () => void,\n  isOpen: boolean\n}) => React.ReactNode\n  "),
  renderFlyout: _stencilReactDesc.PropTypes.func.isRequired.description('Render function to render the content of the flyout.').format("({\n  close: () => void,\n  ref: node\n}) => React.ReactNode"),
  shouldCloseOnClickOutside: _stencilReactDesc.PropTypes.bool.description('Whether the flyout can be closed by clicking outside of it.'),
  flyoutPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.FlyoutPosition)).description('Horizontal position to display the flyout.'),
  onClose: _stencilReactDesc.PropTypes.func.description('Callback called when the flyout is closed.').format('() => void'),
  role: _stencilReactDesc.PropTypes.string.description("Sets the ARIA 'role' attribute on the flyout container.")
};
const WithFlyout = (0, _utils.withTestAttributes)({})(WithFlyoutWithDocs);
WithFlyout.defaultProps = {
  ..._constants.withFlyoutDefaultProps
};
WithFlyout.displayName = 'WithFlyout';
var _default = exports.default = WithFlyout;